import { Injectable } from '@angular/core'
import { Company } from 'depoto-core/src/entities'
import { CoreService } from './index'

@Injectable({
  providedIn: 'root',
})
export class CompanyUtilService {
  constructor(private readonly coreService: CoreService) {}

  public getBatchlessMode(): boolean {
    const company: Company = this.coreService.services.storage.getSync(
      this.coreService.services.storage.keys.auth.company,
    )
    return company?.batchExpirationMode === 'selected-products'
  }

  get arePositionsEnabled(): boolean {
    const company: Company = this.coreService.services.storage.getSync(
      this.coreService.services.storage.keys.auth.company,
    )
    return company?.enabledPositions
  }
}
